import { render, staticRenderFns } from "./mobileUserMessage.vue?vue&type=template&id=6b74510c&"
import script from "./mobileUserMessage.vue?vue&type=script&lang=js&"
export * from "./mobileUserMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports